import { concat } from '../../helpers/common'
import { getLocalStorage, setLocalStorage } from '../../helpers/storage'
import { redirectTo } from '../../helpers/url'
import { ROUTES } from '../../constants/routes'

const MODULE_NAME = 'COGNITO/'

// PLOP_APPEND_PATTERN_ANCHOR_ACTION

export const SUBMIT_LOGIN = concat(MODULE_NAME, 'SUBMIT_LOGIN')
export const SUBMIT_LOGIN_SUCCESS = concat(MODULE_NAME, 'SUBMIT_LOGIN_SUCCESS')
export const SUBMIT_LOGIN_FAILURE = concat(MODULE_NAME, 'SUBMIT_LOGIN_FAILURE')

export const CHECK_AUTH_STATUS = concat(MODULE_NAME, 'CHECK_AUTH_STATUS')
export const CHECK_AUTH_STATUS_SUCCESS = concat(MODULE_NAME, 'CHECK_AUTH_STATUS_SUCCESS')
export const CHECK_AUTH_STATUS_FAILURE = concat(MODULE_NAME, 'CHECK_AUTH_STATUS_FAILURE')

export const SUBMIT_LOGOUT = concat(MODULE_NAME, 'SUBMIT_LOGOUT')
export const SUBMIT_LOGOUT_SUCCESS = concat(MODULE_NAME, 'SUBMIT_LOGOUT_SUCCESS')
export const SUBMIT_LOGOUT_FAILURE = concat(MODULE_NAME, 'SUBMIT_LOGOUT_FAILURE')

// create password for newly created account
export const CREATE_PASSWORD = concat(MODULE_NAME, 'CREATE_PASSWORD')
export const CREATE_PASSWORD_SUCCESS = concat(MODULE_NAME, 'CREATE_PASSWORD_SUCCESS')
export const CREATE_PASSWORD_FAILURE = concat(MODULE_NAME, 'CREATE_PASSWORD_FAILURE')

// create password for forgot password flow
export const CREATE_NEW_PASSWORD = concat(MODULE_NAME, 'CREATE_NEW_PASSWORD')
export const CREATE_NEW_PASSWORD_SUCCESS = concat(MODULE_NAME, 'CREATE_NEW_PASSWORD_SUCCESS')
export const CREATE_NEW_PASSWORD_FAILURE = concat(MODULE_NAME, 'CREATE_NEW_PASSWORD_FAILURE')

export const RESET_PASSWORD = concat(MODULE_NAME, 'RESET_PASSWORD')
export const RESET_PASSWORD_SUCCESS = concat(MODULE_NAME, 'RESET_PASSWORD_SUCCESS')
export const RESET_PASSWORD_FAILURE = concat(MODULE_NAME, 'RESET_PASSWORD_FAILURE')

export const CLEAR_COGNITO_STORE = concat(MODULE_NAME, 'CLEAR_COGNITO_STORE')

// PLOP_APPEND_PATTERN_ANCHOR_ACTION_CREATOR

export function submitLogin(userCredentials) {
  return { type: SUBMIT_LOGIN, userCredentials }
}

export function submitLoginSuccess(loginData) {
  const landingUrl = getLocalStorage('landingUrl')

  if (
    // ignore redirects from the login to login
    !!landingUrl &&
    landingUrl !== ROUTES.login
  ) {
    redirectTo(landingUrl)

    // clear landingUrl after redirection
    setTimeout(() => {
      setLocalStorage('landingUrl', '')
    }, 100)
  }

  if (window.analytics) {
    // Segment analytics implementation
    window.analytics.track('Logged in', {})
  }
  return { type: SUBMIT_LOGIN_SUCCESS, loginData }
}

export function submitLoginFailure(error) {
  return { type: SUBMIT_LOGIN_FAILURE, error }
}

export function checkAuthStatus() {
  return { type: CHECK_AUTH_STATUS }
}

export function checkAuthStatusSuccess(authData) {
  return { type: CHECK_AUTH_STATUS_SUCCESS, authData }
}

export function checkAuthStatusFailure() {
  return { type: CHECK_AUTH_STATUS_FAILURE }
}

export function submitLogout() {
  return { type: SUBMIT_LOGOUT }
}

export function submitLogoutSuccess(loginData) {
  sessionStorage.clear()
  localStorage.clear()
  return { type: SUBMIT_LOGOUT_SUCCESS, loginData }
}

export function submitLogoutFailure(error) {
  return { type: SUBMIT_LOGOUT_FAILURE, error }
}

export function createPassword(data) {
  return { type: CREATE_PASSWORD, data }
}

export function createPasswordSuccess(createPasswordData) {
  return { type: CREATE_PASSWORD_SUCCESS, createPasswordData }
}

export function createPasswordFailure(error) {
  return { type: CREATE_PASSWORD_FAILURE, error }
}

export function createNewPassword(data) {
  return { type: CREATE_NEW_PASSWORD, data }
}

export function createNewPasswordSuccess(createPasswordData) {
  return { type: CREATE_NEW_PASSWORD_SUCCESS, createPasswordData }
}

export function createNewPasswordFailure(error) {
  return { type: CREATE_NEW_PASSWORD_FAILURE, error }
}

export function resetPassword(email, showSuccessToast) {
  return { type: RESET_PASSWORD, email, showSuccessToast }
}

export function resetPasswordSuccess(resetPasswordData) {
  return { type: RESET_PASSWORD_SUCCESS, resetPasswordData }
}

export function resetPasswordFailure(error) {
  return { type: RESET_PASSWORD_FAILURE, error }
}

export function clearCognitoStore() {
  return { type: CLEAR_COGNITO_STORE }
}
